export default "__VITE_ASSET__Bv$eBbVp__"